if ($('.type-post').length) {

    var $text = $('.text');
    var $hr = $text.find('hr').first();

    if ($hr.length) {

        /* ========================
           PEREX – uložíme SI HO NEJDŘÍV
        ======================== */

        var $perex = $('<div class="article-perex"></div>');

        $hr.prevAll().each(function () {
            $perex.prepend(this);
        });

        $hr.remove();

        /* ========================
           vytvoření headingu
        ======================== */

        var $heading = $(
            '<div class="heading">' +
                '<div class="left"></div>' +
                '<div class="right"></div>' +
            '</div>'
        );

        $text.prepend($heading);

        /* ========================
           OG image
        ======================== */

        var ogImage = $('meta[property="og:image"]').attr('content');
        if (ogImage) {
            $heading.find('.left').append(
                $('<img>', {
                    class: 'mainImage',
                    src: ogImage,
                    alt: ''
                })
            );
        }

        /* ========================
           H1 + TIME
        ======================== */

        var $h1 = $('.news-item-detail').find('h1[itemprop="headline"]').first();
        var $time = $('.news-item-detail').find('time').first();

        $heading.find('.right')
            .append($h1)
            .append($time)
            .append($perex);
    }
}
